import RideSolvedRequest, {
  RideSolvedRequestBody,
} from "./ride-solved.request";

const create = (request: RideSolvedRequest): RideSolvedRequestBody => {
  return {
    nodeExclusionCollection: request.nodeExclusionCollection,
    railyRide: request.railyRide,
  };
};

const rideSolvedRequestFactory = {
  create,
};

export default rideSolvedRequestFactory;
